import { inject } from '@angular/core';

import { toTrimmedString } from '../../shared/utils/coerce.utils';
import { SessionStorageService } from '../storage/session-storage.service';
import { UserStore } from '../stores/user.store';
import { LEGACY_AUTH_STORAGE_KEYS } from './legacy-auth-session.constants';

// Restores the legacy identity the login response left in the session, so a reload keeps it.
// The lst-auth arm is `applyLstIdentity`. Call from an injection context.
export function applyLegacyIdentity(): void {
  // Trimmed on purpose: a whitespace-only stored name must not become the display name.
  const userName = toTrimmedString(
    inject(SessionStorageService).get(LEGACY_AUTH_STORAGE_KEYS.userName),
  );
  if (userName) inject(UserStore).setUserName(userName);
}
